import { Pill } from "@monsterindia/global-ui-components";
import React, { useEffect } from "react";

import "./index.css";

export const ALL_FILTERS_SEQUENCE = [
  "experienceRanges",
  "salaryRanges",
  "locations",
  "jobFreshness",
  "companies",
  "industries",
  "functions",
  "title",
  "jobTypes",
  "qualifications",
  "postedBy",
];

const FilterLoader = ({ isMobile = false, scrollToTop = false }) => {
  useEffect(() => {
    if (scrollToTop) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);
  return (
    <>
      {isMobile ? (
        <div className="bg-surface-primary-normal fixed bottom-0 z-[999999] flex w-full items-center gap-6 overflow-x-scroll border-2 px-4 py-3">
          {Array.from({ length: 4 }).map((_: any, index: number) => (
            <div
              className="animateShimmer h-6 w-[73px] rounded-full"
              key={`${_}-${index}`}
            ></div>
          ))}
        </div>
      ) : (
        <div className="bg-surface-primary-normal sticky z-20 flex h-screen flex-col gap-2 border px-3 md:flex md:!w-[288px] md:shrink-0 md:grow-0 md:rounded-2xl">
          <div className="flex flex-col gap-3 pt-3">
            <span className="animateShimmer h-5 w-1/2 rounded-md font-bold"></span>
            <hr className="text-surface-background text-xs" />
          </div>

          <div className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
              <span className="animateShimmer h-5 w-40 rounded-md font-bold"></span>
              <span className="animateShimmer h-5 w-12 rounded-md font-bold"></span>
            </div>

            <div className="flex flex-wrap items-center justify-between gap-2">
              {Array.from({ length: 6 }).map((_: any, index: number) => (
                <Pill
                  key={`${_}-${index}`}
                  id={""}
                  displayName={""}
                  size="small"
                  customClass="animateShimmer border-brand-secondary text-content-secondary h-6 w-[73px]"
                />
              ))}
            </div>
            <hr className="text-surface-background my-3 text-xs" />
          </div>
          <div className="no-scrollbar overflow-auto">
            {ALL_FILTERS_SEQUENCE.map((filter: any) => (
              <div className="flex flex-col gap-3" key={filter}>
                <div className="flex items-center justify-between">
                  <span className="animateShimmer h-5 w-40 rounded-md font-bold"></span>
                  <span className="animateShimmer h-5 w-12 rounded-md font-bold"></span>
                </div>

                <div className="w-full">
                  <input
                    type="text"
                    className="animateShimmer h-8 w-full rounded-md"
                  />
                </div>

                <div className="">
                  <div className="flex size-full flex-col gap-4">
                    <div className="flex flex-col gap-4">
                      {Array.from({ length: 5 }).map(
                        (_: any, index: number) => (
                          <div className="flex gap-4" key={`${_}-${index}`}>
                            <div className="animateShimmer size-5 rounded"></div>
                            <div
                              className={`animateShimmer h-5 w-full rounded`}
                            ></div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
                <span className="animateShimmer ml-12 h-4 w-1/2 rounded-full"></span>
                <hr className="text-surface-background my-3 text-xs" />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FilterLoader;
